import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type TwoColumnsWithFooterShellProps = {
  left: ReactNode;
  right?: ReactNode;
  topRight?: ReactNode;
  className?: string;
  containerClassName?: string;
  gridClassName?: string;
  footer?: ReactNode;
};

export function TwoColumnsWithFooterShell({
  left,
  right,
  topRight,
  className,
  containerClassName,
  gridClassName,
  footer,
}: TwoColumnsWithFooterShellProps) {
  return (
    <div className={cn("bg-background flex min-h-screen flex-col justify-between", className)}>
      <main
        className={cn("flex flex-1 items-center justify-center px-6 py-10", containerClassName)}
      >
        <div className={cn("w-full max-w-5xl", gridClassName)}>
          {!!topRight && <div className="mb-6 flex w-full justify-end">{topRight}</div>}

          <div
            className={cn(
              "grid min-h-100 w-full items-center justify-center gap-30",
              !!right && "md:grid-cols-2",
            )}
          >
            <div className={cn("w-full", !right && "col-span-full flex w-full justify-center")}>
              {left}
            </div>
            {!!right && right}
          </div>
        </div>
      </main>

      {!!footer && footer}
    </div>
  );
}
